<app-topnav></app-topnav>

<div class="top-main-wrapper">


  <div class="dash-header">
    <div class="dash-title">

      <div class="p-field p-grid">
        <div class="p-col-6 p-md-6">
          <h3 class="title-with-count">{{ title }} <span class="total-badge">{{ count() }}</span></h3>
        </div>
        <div class="p-col-6 p-md-6">

          <button pButton pRipple icon="pi pi-plus" [routerLink]="['/admin/news/create']" label=" aggiungi"
          class="p-button p-button-primary -mr-2  pull-right"></button>
          <!-- <button type="button" pButton pRipple icon="pi pi-file-pdf" labe l="Esporta" (click)="exportPdf()" class="p-button-options p-mr-2 pull-right"  tooltipPosition="bottom"></button> -->

        </div>
      </div>

    </div>
  </div>
</div>



<div class="main-inner list">





  <div class="p-fluid">
    <div class="p-field p-grid">
      <div class="p-col-12 p-md-12">

        <app-dynamic-filters [list]="this"></app-dynamic-filters>


        @for ( news of items()  | paginate: { itemsPerPage: pageSize(), currentPage: page(), totalItems: count() }; track  news; let i = $index) {
          <div
            >
          </div>
        }

        <p-table #dt [columns]="cols()" [value]="items()"
          [paginator]="false" [rows]="10">

          <ng-template pTemplate="header" let-columns>
            <tr>
              <th width="100"></th>
              @for (col of cols(); track col) {
                <th>
                  {{col.header}}
                </th>
              }
              <th width="200"></th>
            </tr>

          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columns">
            <tr>


              <td>

                <img [routerLink]="['/admin/news/edit', rowData.id]"
                  [src]="imageUrl + '/' + rowData.photo" width="100px">
                </td>

                @for (col of cols(); track col) {
                  <td>
                    @if (col.field == 'level') {
                      <div>
                        @if (rowData[col.field] == 2) {
                          <span><p-tag severity="success"
                          value="High"></p-tag>
                        </span>
                      }
                      @if (rowData[col.field] == 1) {
                        <span><p-tag severity="success"
                        value="Medium"></p-tag>
                      </span>
                    }
                    @if (rowData[col.field] == 0) {
                      <span><p-tag severity="danger"
                      value="Low"></p-tag></span>
                    }
                  </div>
                }
                @if (col.field == 'page_title') {
                  <div>{{ rowData[col.field] }}</div>
                }
                @if (col.field == 'page_template') {
                  <div>{{ rowData[col.field] }}</div>
                }
                @if (col.field == 'is_active') {
                  <div>
                    @if (rowData[col.field] == 1) {
                      <span><p-tag severity="success" value="SI"></p-tag>
                    </span>
                  }
                  @if (rowData[col.field] == 0) {
                    <span><p-tag severity="danger"
                    value="NO"></p-tag></span>
                  }
                </div>
              }
              @if (col.field == 'is_featured') {
                <div>
                  @if (rowData[col.field] == 1) {
                    <span><p-tag severity="success" value="SI"></p-tag>
                  </span>
                }
                @if (rowData[col.field] == 0) {
                  <span><p-tag severity="danger"
                  value="NO"></p-tag></span>
                }
              </div>
            }
          </td>
        }


        <td class="action">
          <button pButton pRipple icon="pi pi-pencil"
            class="p-button p-button-success pull-right p-mr-2"
          [routerLink]="['/admin/news/edit', rowData.id]"></button>


          <button pButton pRipple icon="pi pi-trash"
            class="p-button p-button-danger pull-right p-mr-2"
          (click)="onDelete(rowData.id)"></button>

        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="p-grid">
    <div class="p-col-12 p-md-4">
      <p class="p-pt-1">
        <span class="count-item pull-left">{{pageSize() * page() - pageSize() +1 }} - {{pageSize() * page()}}
        di {{count()}} risultati</span>
      </p>
    </div>
    <div class="p-col-12 p-md-8">
      <pagination-controls previousLabel="Prev" nextLabel="Next" responsive="true"
        (pageChange)="handlePageChange($event)">
    </pagination-controls>
  </div>
</div>

</div>


</div>
</div>

</div>




<p-confirmDialog [style]="{width: '50vw'}" [baseZIndex]="10000" rejectButtonStyleClass="p-button-text" #cd>

  <p-footer>
    <button type="button" pButton icon="fa fa-close" class="p-button p-button-danger p-mr-2" label="No"
    (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" class="p-button p-button-success p-mr-2" label="Si"
    (click)="cd.accept()"></button>
  </p-footer>

</p-confirmDialog>

<p-toast key="myKey1"></p-toast>

<p-toast key="myKey2">{{error()}}</p-toast>